import { render, staticRenderFns } from "./AddSupplier.vue?vue&type=template&id=20ca0b3f&scoped=true"
import script from "./AddSupplier.vue?vue&type=script&lang=js"
export * from "./AddSupplier.vue?vue&type=script&lang=js"
import style0 from "./AddSupplier.vue?vue&type=style&index=0&id=20ca0b3f&prod&lang=scss&scoped=true"
import style1 from "./AddSupplier.vue?vue&type=style&index=1&id=20ca0b3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ca0b3f",
  null
  
)

export default component.exports